import { Clock, Mail, MapPin, Phone } from "lucide-react";
import { useSettings } from "@/context/SettingsContext";

export default function Contact() {
  const { settings } = useSettings();

  const items = [
    { icon: Phone, label: "Call Us", value: settings?.phone || "240-383-9887", href: `tel:${(settings?.phone || "240-383-9887").replace(/[^0-9]/g, "")}` },
    { icon: Mail, label: "Email", value: settings?.email || "bjelectricservice@gmail.com", href: `mailto:${settings?.email || "bjelectricservice@gmail.com"}` },
    { icon: MapPin, label: "Service Area", value: settings?.service_area || "DC • Maryland • Virginia (DMV)" },
    { icon: Clock, label: "Hours", value: settings?.hours || "Mon–Sat: 7AM–7PM • 24/7 Emergency" },
  ];

  return (
    <section id="contact" className="relative py-24 lg:py-32 bg-[#080809] border-t border-white/5">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="max-w-3xl mb-14">
          <div className="text-xs uppercase tracking-[0.28em] text-yellow-400 font-bold mb-4">
            Get In Touch
          </div>
          <h2 className="font-display font-black text-white text-4xl sm:text-5xl lg:text-6xl tracking-tighter leading-[0.95]">
            Ready when <span className="text-yellow-400">you are</span>.
          </h2>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-4">
          {items.map((it) => {
            const Body = (
              <div
                data-testid={`contact-${it.label.toLowerCase().replace(/[^a-z0-9]/g, '-')}`}
                className="group h-full bg-[#0d0d0f] border border-white/10 hover:border-yellow-400/40 rounded-xl p-7 transition-all hover:-translate-y-1"
              >
                <div className="w-11 h-11 rounded-md bg-yellow-400/10 border border-yellow-400/20 flex items-center justify-center mb-5 group-hover:bg-yellow-400 group-hover:text-black transition-all">
                  <it.icon className="w-5 h-5 text-yellow-400 group-hover:text-black" strokeWidth={1.75} />
                </div>
                <div className="text-xs uppercase tracking-[0.2em] text-white/50 font-bold mb-2">{it.label}</div>
                <div className="text-white font-display font-semibold text-lg tracking-tight leading-tight">{it.value}</div>
              </div>
            );
            return it.href ? (
              <a key={it.label} href={it.href}>{Body}</a>
            ) : (
              <div key={it.label}>{Body}</div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
